var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AnnualSectionTable } from '../common/annualSectionTable';
import { MultigeoLobRow } from '../common/multigeoQueuesByLob';
import { getQueueExpansionKeysForLob, useSelectQueuesByLobPerScenario } from '../common/selectors';
import { TotalSummaryRow } from '../common/totalSummaryRow';
import { getLobExpansionKey, getPrefixedExpansionKey } from '../constants';
import { useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
var LEARNING_CURVE_KEYS = ['effectiveAgents', 'different', 'effectiveRate'];
var getLearningCurveExpansionKey = function (key, itemName) {
    return getPrefixedExpansionKey(key, itemName);
};
var LearningCurveImpactSection = function (_a) {
    var expandedItems = _a.expandedItems, onToggleItem = _a.onToggleItem;
    var t = useTranslation('report', { keyPrefix: 'annual' }).t;
    var data = useSummaryByDisplayMode();
    var chunkSize = useSummaryChunkSize();
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    if (!data)
        return null;
    return (_jsx(_Fragment, { children: LEARNING_CURVE_KEYS.map(function (key) { return (_jsxs(React.Fragment, { children: [_jsx(TotalSummaryRow, { label: t("reportRows.".concat(key)), valueKey: key, data: data, chunkSize: chunkSize, expanded: expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems[key], onToggle: function () { return onToggleItem === null || onToggleItem === void 0 ? void 0 : onToggleItem(key); }, showVariance: key === 'effectiveAgents' }), (expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems[key]) &&
                    lobsPerScenario.map(function (lobEntry) { return (_jsx(MultigeoLobRow, { lob: lobEntry.template, perScenarioLob: lobEntry.perScenarioLob, data: data, chunkSize: chunkSize, keyItem: key, expandedItems: expandedItems, onToggleItem: onToggleItem, expansionKeyPrefix: key, hideConstraintHeader: true }, "".concat(key, "-").concat(lobEntry.lobName))); })] }, key)); }) }));
};
export var LearningCurveImpactTable = function () {
    var t = useTranslation('report', { keyPrefix: 'annual' }).t;
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var queuesByKey = useMemo(function () {
        return Object.fromEntries(LEARNING_CURVE_KEYS.map(function (key) { return [
            key,
            lobsPerScenario.flatMap(function (lobEntry) { return getQueueExpansionKeysForLob(lobEntry, key); }),
        ]; }));
    }, [lobsPerScenario]);
    var lobs = useMemo(function () { return lobsPerScenario.map(function (lobEntry) { return getLobExpansionKey(lobEntry.lobName); }); }, [lobsPerScenario]);
    var expansionItems = useMemo(function () { return __spreadArray(__spreadArray([], LEARNING_CURVE_KEYS, true), LEARNING_CURVE_KEYS.flatMap(function (key) { return __spreadArray(__spreadArray([], lobs.map(function (lob) { return getLearningCurveExpansionKey(key, lob); }), true), queuesByKey[key], true); }), true); }, [lobs, queuesByKey]);
    var getNestedExpansionItems = function (itemName) {
        if (LEARNING_CURVE_KEYS.includes(itemName)) {
            return __spreadArray(__spreadArray([], lobs.map(function (lob) { return getLearningCurveExpansionKey(itemName, lob); }), true), queuesByKey[itemName], true);
        }
        var learningCurveKey = LEARNING_CURVE_KEYS.find(function (key) { return itemName.startsWith("".concat(key, ":")); });
        if (!learningCurveKey)
            return [];
        var lobEntry = lobsPerScenario.find(function (entry) { return itemName === getLearningCurveExpansionKey(learningCurveKey, getLobExpansionKey(entry.lobName)); });
        if (!lobEntry)
            return [];
        return getQueueExpansionKeysForLob(lobEntry, learningCurveKey);
    };
    return (_jsx(AnnualSectionTable, { title: t('learningCurveImpact'), unit: "# ".concat(t('ofAgents')), expansionItems: expansionItems, tableBodyComponent: LearningCurveImpactSection, getNestedExpansionItems: getNestedExpansionItems }));
};
